<template>
  <div class="container">
    <div class="ui grid">
      <h1>User Listing</h1>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <div class="ui grid">
        <div class="ui four column stackable grid form">
          <div class="column">
            <label for="sortStatus">Sort by User Status</label>
            <div class="ui fluid selection dropdown" id="StatusSelect">
              <input
                type="hidden"
                name="userStatus"
                v-model="status"
                id="status"
                @change="onStatusChange"
              />
              <div class="default text">Select Status</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div class="item" value="active">
                  Active
                </div>
                <div class="item" value="inactive">
                  Inactive
                </div>
                <div class="item" value="pending">
                  Pending
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-bar ui grid">
        <div class="ui column stackable grid form">
          <div class="column align-middle" style="padding-left: 0 !important;">
            <div class="ui action input">
              <input
                type="text"
                v-model="search.filterText"
                class
                @keyup.enter="doFilter"
                placeholder="Search for Customers / Users"
              />
              <div class="ui selection dropdown">
                <input
                  type="hidden"
                  name="navigationItem"
                  id="navigationItem"
                  v-model="search.filters"
                  @change="onChange"
                />
                <div class="default text">Select Filter</div>
                <i class="dropdown icon"></i>
                <div class="menu">
                  <div class="item" data-value="">
                    All
                  </div>
                  <div class="item" data-value="customerFirst">
                    First Name
                  </div>
                  <div class="item" data-value="customerLast">
                    Last Name
                  </div>
                  <div class="item" data-value="companyCode">
                    Company Code
                  </div>
                  <div class="item" data-value="customerTitle">
                    Customer Title
                  </div>
                  <div class="item" data-value="customerRole">
                    Customer Role
                  </div>
                </div>
              </div>
              <div class="ui button" @click="doFilter">Search</div>
            </div>
          </div>
        </div>
      </div>
      <vuetable
        ref="vuetable"
        :api-url="apiUrl"
        :fields="fields"
        :data="users"
        pagination-path=""
        :per-page="10"
        :multi-sort="true"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="actions" slot-scope="users">
          <div class="table-button-container">
            <button class="ui button primary" @click="goToUser(users)">
              <i class="fa fa-pencil-square-o"></i>
            </button>
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>
  </div>
</template>

<script>
import VueEvents from "vue-events";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";
import Vue from "vue";
Vue.use(VueEvents);

export default {
  name: "ListUsers",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
  },
  data() {
    return {
      id: "",
      fields: [
        {
          name: "firstName",
          title: "First Name",
          sortField: "firstName",
        },
        {
          name: "lastName",
          title: "Last Name",
          sortField: "lastName",
        },
        {
          name: "title",
          title: "Title",
          sortField: "title",
        },
        {
          name: "email",
          title: "Email",
          sortField: "email",
        },
        {
          name: "roles",
          title: "Roles",
          sortField: "roles",
        },
        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "LastName",
          sortField: "lastName",
          direction: "asc",
        },
      ],
      users: [],
      moreParams: {},
      apiUrl: apiService.getUsersUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      search: [
        {
          filterText: "",
          filters: "",
        },
      ],
      status: "",
    };
  },
  mounted() {
    $(".ui.dropdown").dropdown();
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());
  },
  methods: {
    getUsers() {
      apiService
        .getUsers()
        .then((res) => {
          this.users = res.data[0];
        })
        .then((users) => users);
    },
    goToUser(user) {
      this.$router.push({
        name: "UserDetails",
        params: {
          id: user.rowData.id,
        },
      });
    },

    resetFilter() {
      this.filterText = ""; // clear the text in text input
      this.$events.fire("filter-reset");
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    doFilter() {
      this.$events.fire("filter-set", this.search);
    },
    onChange(event) {
      this.search.filters = event.target.value;
    },
    onFilterSet(data) {
      this.moreParams.filter = data.filters;
      this.moreParams.term = data.filterText;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      delete this.moreParams.status;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onStatusChange(event) {
      this.moreParams.status = event.target.value;
    },
  },
  destroyed: function() {
    this.$events.$off("filter-set");
    this.$events.$off("filter-reset");
  },
};
</script>
